import React from 'react'
import {Button} from '@chakra-ui/react3'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import {PauseIcon, PlayIcon} from '../../icons'

const VideoControl = ({
    isPlaying = false,
    variant = 'mediaGhost',
    size = 'lg',
    onToggle,
    ...props
}) => {
    const {formatMessage} = useIntl()

    return (
        <Button
            aria-label={
                isPlaying
                    ? formatMessage({
                          defaultMessage: 'Pause video',
                          id: 'global.pause-video'
                      })
                    : formatMessage({
                          defaultMessage: 'Play video',
                          id: 'global.play-video'
                      })
            }
            onClick={onToggle}
            variant={variant}
            size={size}
            {...props}
        >
            {isPlaying ? <PauseIcon /> : <PlayIcon />}
        </Button>
    )
}

VideoControl.propTypes = {
    isPlaying: PropTypes.bool,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    variant: PropTypes.oneOf(['mediaGhost', 'mediaFilled']),
    onToggle: PropTypes.func.isRequired
}

export default VideoControl
